import React from "react";
import DateTime from "components/presentation/DateTime";
import { getDateTimeFormat } from "helpers/utils";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useGetDisciplines, useGetScheduleStartList } from "helpers/commonCodes";
import { useGetHeaders } from "helpers/seo";
import { getDiscipline, getLevelRSC } from "helpers/rsc";
import ScheduleDataTime from "components/presentation/ScheduleDataTime";
import { useDispatch, useSelector } from "react-redux";
import { changeTimeRsc } from "state-management/actions";
import SelectorTimeZone from "./selectors/selector-timezone";

function PageHeader({ data, title, venue, dateTime, formatDate, showEvent }) {
  return ('')
}
export function Updated() {
  const d = new Date();
  let time = d.getTime();
  return (
    <div>
      Last Refresh: <DateTime datetime={time} format={"HH:mm:ss"} />
    </div>
  );
}

export function PageHeaderMenu() {
  const { mirs_competition, mirs_discipline, mirs_language } = useUrlFriendlyToParameters();
  const dataDisciplines = useGetDisciplines({
    mirs_competition: mirs_competition,
    mirs_language: mirs_language,
  });
  const { lineTop, lineBottom } = useGetHeaders();
  const titlelength = lineBottom?.length;
  let classtitlelength;
  if (titlelength <= 24) {
    classtitlelength = "title-small";
  } else if (titlelength >= 25 && titlelength < 45) {
    classtitlelength = "title-medium";
  } else if (titlelength >= 45 && titlelength < 81) {
    classtitlelength = "title-big";
  } else if (titlelength > 80) {
    classtitlelength = "title-superbig";
  } else {
    classtitlelength = "";
  }
  const discipline = dataDisciplines?.disciplines?.find((item) => item.code === mirs_discipline)?.description;
  return (
    <div id='atos-h1' className="page-header-container">
      <div className="container page-header">
        {mirs_discipline ? (
          <>
            <span aria-hidden="true" className={`${mirs_discipline} page-header-icon`} alt={discipline} ></span>
          </>
        ) : (
          ""
        )}

        <h1>
          {discipline && <div className="h1-small"> {lineTop}</div>}
          <div className={`h1-big ${classtitlelength}`}> {lineBottom}</div>
        </h1>

      </div>
    </div>
  );
}

export function PageVenueDate() {
  const rsctime = useSelector((state) => state.appGlobal.rsctime)
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters();
  const isPhaseLevel = getLevelRSC(mirs_rsc) === 'PHASE'

  let discipline
  if (mirs_discipline === "GLF") {
    discipline = getDiscipline(rsctime?.schedule?.code);
  } else {
    discipline = getDiscipline(rsctime?.code);
  }
  const sw = discipline === mirs_discipline;
  const scheduleSL = useGetScheduleStartList();

  let scheduleItem
  if (isPhaseLevel && sw) {
    scheduleItem = sw && rsctime?.schedule
  } else {
    scheduleItem = scheduleSL?.find(schedule => schedule?.code === mirs_rsc)
    if (!scheduleItem) {
      scheduleItem = sw && rsctime?.schedule
    }

  }


  let formatDateTime
  let _venue
  let _location = Array.isArray(scheduleSL) && scheduleSL[0]?.location?.description
  //let _venue = scheduleSL?.schedules[0]?.location?.description;
  if (scheduleItem) {
    _venue = scheduleItem?.venue?.description;
    _location = isPhaseLevel ? _venue : scheduleItem?.location?.description;
    formatDateTime = getDateTimeFormat('DateTimeLong');
  }


  return (
    <div className="container page-venue-container d-flex flex-column">
      <div className="d-flex flex-row">
        <span className="mirs-icon-location" />
        <span className="venue">
          {_location}
        </span>
      </div>
      <div className="d-flex flex-column flex-md-row align-items-baseline">
        <span className="me-3 date"><ScheduleDataTime data={scheduleItem} format={"DateTimeLong"} formatDateAddText={"DateLong"} /></span>
        <span className="mt-2 mt-md-0"><SelectorTimeZone /></span>
      </div>


    </div>
  );
}





export function ReduxTimeRsc() {
  const dispatch = useDispatch();
  return function (value) {
    dispatch(changeTimeRsc(value));
  }
}


export default PageHeader;
